import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Portfolio.css";
import pro1 from "../Assets/project1.png";
import pro2 from "../Assets/project2.png";
import pro3 from "../Assets/project3.png";
import pro4 from "../Assets/project4.png";
import pro5 from "../Assets/project5.png";
import pro6 from "../Assets/project6.png";

const Portfolio = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("portfolio-slide-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    cardsRef.current.forEach((card) => card && observer.observe(card));
    return () => observer.disconnect();
  }, []);

  const cardsData = [
    {
      img: pro1,
      title: "Oggi Beach – Luxury Beach Club Experience",
      text: " Oggi Beach – Luxury Beach Club Experience is a premium beach destination in Italy offering an elegant seaside experience. The website reflects a perfect blend of relaxation, luxury, and coastal lifestyle, showcasing beach services, events, and fine hospitality for travelers seeking comfort by the sea.",
      tags: ["Web", "B2C", "Hospitality"],
      link: "https://www.oggibeach.it/",
    },

    {
      img: pro2,
      title: "Mayweather Boxing + Fitness",
      text: "Mayweather Boxing + Fitness offers high-energy group workouts designed by Floyd Mayweather, combining boxing techniques with strength and cardio training. The program builds fitness, confidence, and community, welcoming everyone from beginners to athletes.",
      tags: ["Web", "B2C", "Fitness"],
      link: "https://mayweather.fit/",
    },
    {
      img: pro3,
      title: "XPT Life – Extreme Performance Training",
      text: "XPT Life is a holistic performance lifestyle system founded by Laird Hamilton & Gabby Reece, built around three core pillars: Breathe, Move, Recover. It offers an app, immersive experiences, certifications, and a community approach to cultivate resilience, health, and adaptability.",
      tags: ["Web", "B2C", "Health"],
      link: "https://xptlife.com/",
    },

    {
      img: pro4,
      title: "Val Mivola – Sustainable Living & Nature Retreat",
      text: "Val Mivola represents a serene retreat focused on sustainability, nature, and mindful living. The platform highlights eco-conscious accommodations and immersive experiences designed to reconnect people with nature in a calm and authentic environment.",
      tags: ["Web", "B2C", "Sustainability"],
      link: "https://www.valmivola.com/",
    },

    {
      img: pro5,
      title: "Burggraben – Swiss Hospitality & Heritage",
      text: "Burggraben is a Swiss hospitality brand that blends tradition with modern comfort. The website showcases refined dining, cultural heritage, and a welcoming atmosphere, offering visitors an elegant digital experience rooted in local authenticity.",
      tags: ["Web", "B2C", "Hospitality"],
      link: "https://burggraben.ch/",
    },

    {
      img: pro6,
      title: "Coastliner Boats – Premium Marine Craft",
      text: "Coastliner Boats specializes in high-quality boats designed for performance, comfort, and durability. The website presents a sleek marine brand identity, highlighting innovative craftsmanship and modern boating solutions for sea enthusiasts worldwide.",
      tags: ["Web", "B2C", "Marine"],
      link: "https://coastliner-boats.com/",
    },
  ];

  return (
    <section className="portfolio-section">
      <div className="portfolio-header">
        <h4 className="portfolio-header-subtitle">Our Work</h4>
        <h1 className="portfolio-header-title">What have we done?</h1>
        <p className="portfolio-header-description">
          OnenessWeb helps companies go forward on the digitalisation journey.
          We deliver meaningful applications and services with agile teams of
          passionate developers and designers.
        </p>
      </div>

      <h1 className="portfolio-heading">Work</h1>

      {/* Cards Grid */}
      <div className="portfolio-cards-container">
        {cardsData.map((card, index) => (
          <div
            key={index}
            className={`portfolio-card ${
              index % 2 === 0 ? "portfolio-card-left" : "portfolio-card-right"
            }`}
            ref={(el) => (cardsRef.current[index] = el)}
          >
            <div className="portfolio-card-image">
              <img src={card.img} alt={card.title} />
            </div>
            <div className="portfolio-card-content">
              <h3 className="portfolio-card-title">{card.title}</h3>
              <p className="portfolio-card-text">{card.text}</p>
              <div className="portfolio-card-tags">
                {card.tags.map((tag, i) => (
                  <span key={i} className="portfolio-tag">
                    {tag}
                  </span>
                ))}
              </div>
              <a href={card.link} className="portfolio-readmore">
                Read more
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <section className="portfolio-cta">
        <h3 className="portfolio-cta-subtitle">Have an idea?</h3>
        <h1 className="portfolio-cta-title">
          Let's build together and make it reality.
        </h1>
        <Link to="/contact" className="portfolio-btn">
          Get in Touch
        </Link>
      </section>
    </section>
  );
};

export default Portfolio;
